import React from 'react';
import Header from '../components/Header/Header';
import MainChats from '../components/Chats/Chats';
import welcome from '../assets/welcome.svg';

const Chats = () => {
  return (
    <>
      <Header />
      <div>
        <div className="mainchats">
          <div className="chats--left">
            <MainChats />
          </div>
          <div className="chats--right">
            <img className="onboarding" src={welcome} alt="badge" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Chats;
